import { Box } from "@/components/ui/box";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import {useEffect, useState} from "react";


export default function LoadingChatBubble({ type, ...containerProps}) {
    const [counter, setCounter] = useState(0)

    useEffect(() => {
        const id = setInterval(() => {
            console.log("TICK!")
            setCounter(c => c < 3 ? c+1 : 0)
        }, 750)

        return () => clearInterval(id)
    }, [])

    return (<HStack className={type === 'sent' ? 'justify-end' : 'justify-start'} {...containerProps}>
        <Box className={`${type === 'sent' ? 'bg-white' : 'bg-primary-900'} max-w-[80%] py-2 px-3 rounded-md border border-trueGray-300`}>
            <Text className={`${type === 'sent' ? 'text-black' : 'text-white'} break-words`}>
                {Array.from({ length: 3 }).map((_, i) => (
                    <Text
                        key={i}
                        style={{ opacity: i < counter ? 1 : 0, color: 'white' }} // still takes space
                    >
                        .
                    </Text>
                ))}
            </Text>
        </Box>
    </HStack>)

}
